import {
  CircularProgressProps,
  Box,
  CircularProgress,
  Typography,
} from '@mui/material';
import { useMedia } from 'react-use';

export function CircularProgressWithLabel(
  props: CircularProgressProps & {
    value: number;
    label: string;
    realvalue: any;
  },
) {
  const isWide = useMedia('(min-width: 464px)');
  return (
    <Box
      sx={{
        position: 'relative',
        display: 'inline-flex',
      }}
    >
      <CircularProgress
        variant="determinate"
        {...props}
        size={isWide ? '144px' : '120px'}
        value={100}
        // eslint-disable-next-line sonarjs/no-duplicate-string
        sx={{ color: 'rgba(127 127 127/0.2)' }}
      />
      <CircularProgress
        variant="determinate"
        {...props}
        size={isWide ? '144px' : '120px'}
        sx={{ position: 'absolute', left: 0 }}
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="body1"
          component="div"
          color="text.secondary"
          sx={{ textAlign: 'center' }}
        >
          {props.label}
          <br />
          {props.realvalue}
          <br />
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  );
}
